import {
  CMS_LIST,
  CMS_ADD,
  CMS_EDIT,
  CMS_DETAILS,
  CMS_DELETE,
} from "../constants/api-path";
import httpClient from "./http.interceptor";

export const getAppCmsPages = (formData: any): Promise<any> => {
  return httpClient.get(CMS_LIST, {
    params: {
      page: formData.page,
      pageSize: formData.limit,
      search: formData.search,
      sort: formData.sort,
    },
  });
};

export const getAppCmsPageDetails = (id: number): Promise<any> => {
  return httpClient.get(CMS_DETAILS + id);
};

function slugify(input: string): string {
  return (input || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

export const addAppCmsPage = (formData: {
  page_name: string;
  description: string;
}): Promise<any> => {
  const payload: any = {
    // Fields expected by backend Service
    page_name: formData.page_name,
    description: formData.description,
  };
  return httpClient.post(CMS_ADD, payload);
};

export const updateAppCmsPage = (
  id: number,
  formData: { page_name: string; description: string },
): Promise<any> => {
  const payload: any = {
    // Fields expected by backend Service
    page_name: formData.page_name,
    description: formData.description,
  };
  return httpClient.put(CMS_EDIT + id, payload);
};

export const deleteAppCmsPage = (id: number): Promise<any> => {
  // Note: Backend route definition for delete seems to miss :id.
  // Expose conventional path; adjust if backend expects query param instead.
  return httpClient.delete(CMS_DELETE + id);
};
